import { mountBattleApp } from './battle.jsx';
import { mountPageApps } from './pages.jsx';

function installInitialState(rootId, stateId, state) {
    const root = document.createElement('div');
    root.id = rootId;
    const script = document.createElement('script');
    script.id = stateId;
    script.type = 'application/json';
    script.textContent = JSON.stringify(state);
    document.body.replaceChildren(script, root);
    const footer = document.createElement('footer');
    footer.className = 'sd-information-footer';
    footer.innerHTML = '<nav aria-label="サービス情報"><a href="/privacy">プライバシーポリシー</a><a href="/support">サポート・問い合わせ</a></nav>';
    document.body.append(footer);
}

async function loadCloudflareRoom(roomCode) {
    const path = `/api/v1/rooms/${encodeURIComponent(roomCode)}`;
    const load = async () => {
        const response = await fetch(path, { headers: { Accept: 'application/json' } });
        return response.ok ? response.json() : null;
    };
    let room = await load();
    if (room && !room.players?.some((player) => player.is_me)) {
        // The server can recover the encrypted session without exposing its token to JavaScript.
        const restored = await fetch(`/api/web/rooms/${encodeURIComponent(roomCode)}/reconnect`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Secret-Digits-Web': '1' },
            body: '{}',
        });
        if (restored.ok) room = await load();
    }
    return room;
}

async function bootstrapCloudflarePage() {
    if (!document.querySelector('meta[name="secret-digits-runtime"][content="cloudflare"]')) {
        return;
    }
    const path = window.location.pathname;
    const common = { backend: 'cloudflare', csrf_token: '', lobby_url: '/', solo_url: '/solo' };
    if (path === '/solo') {
        installInitialState('secret-digits-solo-root', 'secret-digits-solo-state', common);
        return;
    }

    const battle = path.match(/^\/rooms\/([^/]+)\/battle$/u);
    if (battle) {
        const roomCode = decodeURIComponent(battle[1]).toUpperCase();
        const room = await loadCloudflareRoom(roomCode);
        const me = room?.players?.find((player) => player.is_me);
        const matchResponse = room?.match_id
            ? await fetch(`/api/v1/matches/${room.match_id}`, { headers: { Accept: 'application/json' } })
            : null;
        const match = matchResponse?.ok ? await matchResponse.json() : null;
        installInitialState('secret-digits-battle-root', 'secret-digits-battle-state', match && me ? {
            ...common,
            invalid_session: false,
            room_code: roomCode,
            match_id: match.match_id,
            player_id: me.id,
            player_name: me.name,
            player_token: '',
            match,
            battle_url: path,
            join_url: `/join/${encodeURIComponent(roomCode)}`,
            reconnect_url: match ? `/api/v1/matches/${match.match_id}/reconnect` : '',
        } : {
            ...common,
            invalid_session: true,
            room_code: roomCode,
            join_url: `/join/${encodeURIComponent(roomCode)}`,
            reconnect_url: `/api/web/rooms/${encodeURIComponent(roomCode)}/reconnect`,
            battle_url: path,
        });
        return;
    }

    const waiting = path.match(/^\/rooms\/([^/]+)\/waiting$/u);
    if (waiting) {
        const roomCode = decodeURIComponent(waiting[1]).toUpperCase();
        const room = await loadCloudflareRoom(roomCode);
        installInitialState('secret-digits-waiting-root', 'secret-digits-waiting-state', {
            ...common,
            room_code: roomCode,
            invite_url: `${window.location.origin}/join/${encodeURIComponent(roomCode)}`,
            battle_url: `/rooms/${encodeURIComponent(roomCode)}/battle`,
            join_url: `/join/${encodeURIComponent(roomCode)}`,
            realtime_topic: room?.realtime_topic ?? null,
            invalid_session: !room?.players?.some((player) => player.is_me),
        });
        return;
    }

    const invitation = path.match(/^\/join\/([^/]+)$/u);
    const roomCode = invitation ? decodeURIComponent(invitation[1]).toUpperCase() : '';
    let invitedRoom = null;
    if (roomCode) {
        const response = await fetch(`/api/v1/rooms/${encodeURIComponent(roomCode)}`, { headers: { Accept: 'application/json' } });
        invitedRoom = response.ok ? await response.json() : null;
    }
    installInitialState('secret-digits-lobby-root', 'secret-digits-lobby-state', {
        ...common,
        invitation_mode: Boolean(invitation),
        invited_room: invitedRoom,
        prefill_room_code: roomCode,
    });
}

async function mountApps() {
    await bootstrapCloudflarePage();
    mountPageApps();
    mountBattleApp();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => void mountApps(), { once: true });
} else {
    void mountApps();
}

if ('serviceWorker' in navigator && window.isSecureContext) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {
            // PWA機能が利用できなくても通常のWeb対戦は継続する。
        });
    });
}
